import { Component, inject } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProgramModalInAppNotificationViewModel } from '@program-suite/data-common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'lib-in-app-notification-modal',
  imports: [],
  templateUrl: './in-app-notification-modal.component.html',
  styleUrl: './in-app-notification-modal.component.scss',
})
export class InAppNotificationModalComponent {
  dialogRef = inject(MatDialogRef<InAppNotificationModalComponent>);
  data: ProgramModalInAppNotificationViewModel = inject(MAT_DIALOG_DATA);
  private sanitizer = inject(DomSanitizer);

  get title(): string {
    return this.data.header ?? 'Notification';
  }

  get sanitizedBody(): SafeHtml {
    return this.sanitizer.sanitize(1, this.data.body ?? '') || this.sanitizer.bypassSecurityTrustHtml(this.data.body ?? '');
  }

  close() {
    this.dialogRef.close();
  }
}
